/* shuffle-excerpt.js — randomise which items show in an "excerpt" of a larger
   set, so homepage teasers feel fresh each visit (client-side, so it's immune
   to page caching).

   Usage: mark the items' container with [data-shuffle]. Optionally:
     [data-shuffle-show="N"]      — reveal only N of the rendered pool.
     [data-shuffle-cap="g:P"]     — show at most P% of the N from items whose
                                    [data-shuffle-group="g"] — e.g. keep the
                                    kids kits from flooding the kits rail. The
                                    remaining slots fill from other groups; if
                                    there aren't enough, capped items backfill.

   Render the overflow items (beyond N) with the `hidden` attribute so first
   paint and the no-JS case still show the right count — the shuffle then just
   swaps which ones are revealed, with no flash or layout jump. */
(function () {
  if (window.__bfShuffleExcerpt) return;
  window.__bfShuffleExcerpt = true;

  function shuffleInPlace(arr) {
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  }

  // Pick up to `show` items from the already-shuffled pool, allowing at most
  // `capCount` from `capGroup`. Backfill from capped overflow if the other
  // groups can't fill the quota (so the rail is never short).
  function pickWithCap(items, show, capGroup, capCount) {
    const selected = [];
    const overflow = [];
    let capUsed = 0;
    items.forEach(el => {
      if (selected.length >= show) return;
      if (capGroup && el.dataset.shuffleGroup === capGroup) {
        if (capUsed < capCount) { selected.push(el); capUsed++; }
        else overflow.push(el);
      } else {
        selected.push(el);
      }
    });
    for (let i = 0; i < overflow.length && selected.length < show; i++) {
      selected.push(overflow[i]);
    }
    return selected;
  }

  function shuffleAll() {
    document.querySelectorAll('[data-shuffle]').forEach(container => {
      if (container.dataset.shuffled) return;
      container.dataset.shuffled = '1';

      const show  = parseInt(container.dataset.shuffleShow, 10) || 0;
      const items = shuffleInPlace(Array.from(container.children));
      if (items.length < 2) return;

      let selected;
      if (show > 0 && container.dataset.shuffleCap) {
        const [grp, pctStr] = container.dataset.shuffleCap.split(':');
        const pct = parseFloat(pctStr) || 0;
        selected = pickWithCap(items, show, grp, Math.floor(show * pct / 100));
      } else if (show > 0) {
        selected = items.slice(0, show);
      } else {
        selected = items;
      }

      const chosen = new Set(selected);
      const frag = document.createDocumentFragment();
      selected.forEach(el => { el.hidden = false; frag.appendChild(el); });
      items.forEach(el => {
        if (chosen.has(el)) return;
        if (show > 0) el.hidden = true;
        frag.appendChild(el);
      });
      container.appendChild(frag);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', shuffleAll);
  } else {
    shuffleAll();
  }
})();
